// This component was created to match heading styles from the Grow design system (v2)
// with the intention that we gradually migrate away from using the <Typography /> component
import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

type HeadingSize = 1 | 2 | 3 | 4 | 5 | 6;

type HeadingProps = {
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  size?: HeadingSize;
  children: React.ReactNode;
};

const StyledHeading = styled.span<{ size: HeadingSize }>`
  font-weight: bold;
  line-height: 1.2;

  ${(props) =>
    props.theme.typography.heading.sizes.map((size, index) =>
      props.size === index + 1
        ? css`
            font-size: ${size.mobile}px;
          `
        : undefined
    )}

  @media ${(props) => props.theme.bp.mobileUp} {
    ${(props) =>
      props.theme.typography.heading.sizes.map((size, index) =>
        props.size === index + 1
          ? css`
              font-size: ${size.desktop}px;
            `
          : undefined
      )}
  }
`;

export const Heading = ({ as = "h2", size = 2, ...rest }: HeadingProps) => (
  <StyledHeading as={as} size={size} {...rest} />
);
